import type * as React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

interface ChartCardProps {
  title: string;
  description?: string;
  toolbar?: React.ReactNode;
  children: React.ReactNode;
  contentClassName?: string;
}

export function ChartCard({
  title,
  description,
  toolbar,
  children,
  contentClassName,
}: ChartCardProps) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-start justify-between space-y-0 pb-4">
        <div className="space-y-1">
          <CardTitle className="text-base font-semibold">{title}</CardTitle>
          {description && <CardDescription>{description}</CardDescription>}
        </div>
        {toolbar && <div>{toolbar}</div>}
      </CardHeader>
      <CardContent className={contentClassName ?? 'px-2 pb-5 sm:px-6'}>{children}</CardContent>
    </Card>
  );
}
